import { createComponentPreviewMapperModel } from '@wix/editor-elements-integrations';
import { composeMapper } from '@wix/editor-elements-preview-utils';
import { PreviewWrapperProps } from '@wix/editor-elements-types';
import { getSocialCompBlockingLayerProps } from '../../../preview-utils/socialComponents';
import {
  VKShareButtonDefinition,
  VKShareButtonProps,
} from '../VKShareButton.types';
import { props as viewerPropsMapper } from './VKShareButton.mapper';

const props = composeMapper<
  PreviewWrapperProps<VKShareButtonProps>,
  VKShareButtonDefinition
>()(
  viewerPropsMapper,
  { add: ['isSocialInteractionAllowed'] },
  (resolver, deps, carmiData) => {
    const viewerProps = resolver(deps, carmiData);
    // TODO - remove this workaround once the feature is working properly
    const currentUrl = { href: 'https://www.wix.com/' };
    const socialUrl = 'https://www.wix.com/';

    return {
      ...viewerProps,
      currentUrl,
      socialUrl,
      previewWrapperProps: {
        ...getSocialCompBlockingLayerProps(deps.isSocialInteractionAllowed),
      },
    };
  },
);

export default createComponentPreviewMapperModel({
  props,
});
